import { useEffect } from 'react';
import Hero from './components/Hero';
import About from './components/About';
import Services from './components/Services';
import WhyChooseUs from './components/WhyChooseUs';
import ProjectShowcase from './components/ProjectShowcase';
import CallToAction from './components/CallToAction';
import Footer from './components/Footer';
import Navbar from './components/Navbar';
import WhatsAppButton from '../../components/feature/WhatsAppButton';
import { useSEO, generateLocalBusinessSchema, generateFAQSchema } from '../../utils/seo';

export default function HomePage() {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';

  // Combine LocalBusiness and FAQ schemas
  useEffect(() => {
    const localBusinessSchema = generateLocalBusinessSchema();
    const faqSchema = generateFAQSchema();
    
    // Create combined schema with @graph
    const combinedSchema = {
      "@context": "https://schema.org",
      "@graph": [localBusinessSchema, faqSchema]
    };

    // Add schema to head
    let existingScript = document.querySelector('script[type="application/ld+json"]');
    if (existingScript) {
      existingScript.textContent = JSON.stringify(combinedSchema);
    } else {
      const script = document.createElement('script');
      script.type = 'application/ld+json';
      script.textContent = JSON.stringify(combinedSchema);
      document.head.appendChild(script);
    }

    return () => {
      // Cleanup on unmount
      const script = document.querySelector('script[type="application/ld+json"]');
      if (script) {
        script.remove();
      }
    };
  }, []);

  useSEO({
    title: 'Johannesburg Skip Hire & Waste Management | S2K Waste Services',
    description: 'S2K Waste Services offers reliable skip hire and waste management solutions in Johannesburg. Mini skip 2 & 3 ton bins available. Affordable rates, fast delivery, eco-friendly disposal for homes, businesses, and construction projects. Book your skip today!',
    keywords: 'skip hire Johannesburg, waste management Johannesburg, mini skip hire, affordable skip hire, residential skip hire, commercial skip hire, construction waste removal',
    canonical: siteUrl
  });

  return (
    <>
      <Navbar />
      <Hero />
      <About />
      <Services />
      <WhyChooseUs />
      <ProjectShowcase />
      <CallToAction />
      <Footer />
      <WhatsAppButton />
    </>
  );
}
